import gql from 'graphql-tag';

import type { EnterpriseNoticeAcceptanceLogsV1GetByUserIdAndOrganizationIdQuery } from 'bundles/naptimejs/resources/__generated__/EnterpriseNoticeAcceptanceLogsV1';

export type EnterpriseNoticeAcceptanceQueryVariables = {
  userId: string;
  thirdPartyOrganizationId: string;
  requirePreJoinCheck: boolean;
};

export type EnterpriseNoticeAcceptanceQuery = EnterpriseNoticeAcceptanceLogsV1GetByUserIdAndOrganizationIdQuery;

const EnterpriseNoticeAcceptanceQueryText = gql`
  query EnterpriseNoticeAcceptanceQuery(
    $userId: String!
    $thirdPartyOrganizationId: String!
    $requirePreJoinCheck: Boolean!
  ) {
    # Naptime query for privacy notice compliance
    EnterpriseNoticeAcceptanceLogsV1 @naptime @include(if: $requirePreJoinCheck) {
      getByUserIdAndOrganizationId(userId: $userId, thirdPartyOrganizationId: $thirdPartyOrganizationId) {
        elements {
          id
        }
      }
    }
  }
`;

export default EnterpriseNoticeAcceptanceQueryText;
